<template>
  <div style="clear: both;">
    <div style="float: left;">A.</div>
    <div style="margin-left: 40px;">
      <root-element
        :rootElement="answer"
        :entryItems="entryItems"
        v-if="answer"
        @updated="updated($event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Answer",
  props: ["answer", "entryItems"],
  methods: {
    updated(event) {
      this.$emit("updated", event);
      // console.log(event)
    }
  }
};
</script>
